import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import cy from './locales/cy.json';
import gd from './locales/gd.json';

const resources = {
  en: { translation: en },
  cy: { translation: cy },
  gd: { translation: gd }
};

export const languages = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'cy', name: 'Cymraeg', flag: '🏴󠁧󠁢󠁷󠁬󠁳󠁿' },
  { code: 'gd', name: 'Gàidhlig', flag: '🏴󠁧󠁢󠁳󠁣󠁴󠁿' }
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'cy', 'gd'],
    
    interpolation: {
      escapeValue: false // React already escapes
    },
    
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'seen_beyond_language',
      caches: ['localStorage']
    }
  });

export default i18n;
